import { createSelector } from 'reselect'
import { currentUserSelector } from 'selectors/currentUser'

export const getId = (state, props) => props.cardContext.id

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

export const getHeartbeats = (state, props) => {
  return state.kanbo.heartbeats
}

export const editingUsersSelector = createSelector(
  [
    getId,
    getHeartbeats,
    currentUserSelector,
  ],
  (
    id,
    heartbeats,
    currentUser,
  ) =>
    heartbeats
      .filter(heartbeat =>
        heartbeat.userId !== currentUser.id &&
        heartbeat.location === `card-${id}` &&
        heartbeat.action === 'Editing'
      )
      .map(heartbeat => heartbeat.userId)
)

const getIncomingMailEnabled = state => state.kanbo.config.incomingMail

const getEmailSenderEnabled = state => state.kanbo.config.plugins.includes('email-sender')

const sendEmailFromCardEnabledSelector = createSelector(
  [
    getIncomingMailEnabled,
    getEmailSenderEnabled,
  ],
  (
    incomingMailEnabled,
    emailSenderEnabled,
  ) =>
    Boolean(incomingMailEnabled && emailSenderEnabled)
)

export default createSelector(
  [
    getId,
    getBoardId,
    editingUsersSelector,
    sendEmailFromCardEnabledSelector,
  ],
  (
    id,
    boardId,
    editingUsers,
    sendEmailFromCardEnabled,
  ) => ({
    id,
    boardId,
    editingUsers,
    sendEmailFromCardEnabled,
  })
)
